"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageHeader = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../utils/classFunctions");
const LanguageSwitcher_1 = require("./LanguageSwitcher");
const UserLoginInfo_1 = require("./UserLoginInfo");
const UserMoneyInfo_1 = require("./UserMoneyInfo");
require("./index.scss");
const className = 'page-header';
class PageHeader extends react_1.default.PureComponent {
    render() {
        const { modificators, onLanguageChange, selectedLanguage, userName, userBalance, showCharge, onConfirmCharge, } = this.props;
        const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
        return (react_1.default.createElement("div", { className: classNames },
            react_1.default.createElement("div", { className: `${className}__container` },
                react_1.default.createElement("a", { href: '/', className: `${className}__logo` },
                    react_1.default.createElement("img", { title: 'Malesia', alt: 'Malesia logo', src: '/svg/malesia-logo.svg' })),
                react_1.default.createElement("div", { className: `${className}__panel` },
                    react_1.default.createElement("div", { className: `${className}__panel-item ${className}__panel-item--login` },
                        react_1.default.createElement(UserLoginInfo_1.UserLoginInfo, { userName: userName })),
                    react_1.default.createElement("div", { className: `${className}__panel-item ${className}__panel-item--separator` }),
                    react_1.default.createElement("div", { className: `${className}__panel-item ${className}__panel-item--money` },
                        react_1.default.createElement(UserMoneyInfo_1.UserMoneyInfo, { userBalance: userBalance, showCharge: showCharge, onConfirmCharge: onConfirmCharge })),
                    react_1.default.createElement("div", { className: `${className}__panel-item ${className}__panel-item--separator` }),
                    react_1.default.createElement("div", { className: `${className}__panel-item ${className}__panel-item--language` },
                        react_1.default.createElement(LanguageSwitcher_1.LanguageSwitcher, { onLanguageChange: onLanguageChange, selectedLanguage: selectedLanguage }))))));
    }
}
exports.PageHeader = PageHeader;
PageHeader.defaultProps = {
    onLanguageChange: () => {
    },
    selectedLanguage: 'en',
};
//# sourceMappingURL=index.js.map